import axios from 'axios';

const generateAxios = (contentType: string) => {
    const api = axios.create({
        baseURL: import.meta.env.VITE_API_URL,
        headers: {
            'Content-Type': contentType,
        },
        validateStatus: (status) => (status >= 200 && status < 300) || status === 302,
    });

    return api;
};

const externalAxios = (contentType: string) => {
    return axios.create({
        baseURL: '',
        headers: {
            'Content-Type': contentType,
        },
        validateStatus: (status) => (status >= 200 && status < 300) || status === 302,
    });
};

export const $api = generateAxios('application/json');
export const $apiFormData = generateAxios('multipart/form-data');
export const $apiExternal = externalAxios('application/json');
